import { NgZone } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { HttpRequest, HttpEventType, HttpParams, HttpHeaders } from '@angular/common/http';
import { makeStateKey } from '@angular/platform-browser';
import { Observable, throwError, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as memoryCache from 'memory-cache';
import { printErrorHandler } from 'src/app/util';
import { CSP_NONCE_KEY } from '../tokens/csp-nonce.statekey';
import { GeneratorEnv } from '../../web-generator/generator-env-token';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@techmore/global";
import * as i3 from "@ngx-translate/core";
import * as i4 from "@angular/platform-browser";
import * as i5 from "./logger.service";
import * as i6 from "../../web-generator/generator-env-token";
export class CommonHttpClientService {
    constructor(http, globalComponentService, translateService, platformId, transferState, ngZone, loggerService, generatorEnv) {
        this.http = http;
        this.globalComponentService = globalComponentService;
        this.translateService = translateService;
        this.platformId = platformId;
        this.transferState = transferState;
        this.ngZone = ngZone;
        this.loggerService = loggerService;
        this.generatorEnv = generatorEnv;
        this.words = {};
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.translateService.get('modal.errorTitle').subscribe(s => this.words.errorTitle = s);
        this.translateService.get('error.addressNotFound').subscribe(s => this.words.addressNotFound = s);
        this.translateService.get('error.undefinedError').subscribe(s => this.words.undefinedError = s);
    }
    get(url, options, noDefaultPrintAction = false) {
        const httpOptions = Object.assign({ responseType: 'json' }, options);
        if (httpOptions['params']) {
            httpOptions['params'] = new HttpParams({ fromObject: httpOptions['params'] });
        }
        if (httpOptions['headers']) {
            httpOptions['headers'] = new HttpHeaders(httpOptions['headers']);
        }
        const req = new HttpRequest('GET', url, httpOptions);
        return this.onHttpRequest(req).pipe(catchError((error, caught) => {
            if (!noDefaultPrintAction) {
                return printErrorHandler(error, url, this.translateService, this.globalComponentService, this.words, this.isBrowser, this.loggerService);
            }
            else {
                return throwError(error);
            }
        }));
        // return this.http.get<HttpResponse<T>>(`${url}`, options).pipe(
        //   catchError((error, caught) => {
        //     if (!noDefaultPrintAction) {
        //       return printErrorHandler(error, url, this.translateService, this.globalComponentService, this.words, this.isBrowser);
        //     } else {
        //       return throwError(error);
        //     }
        //   }),
        // ) as Observable<unknown> as Observable<T>;
    }
    post(url, data, options, noDefaultPrintAction = false) {
        return this.http.post(`${url}`, data, options).pipe(catchError((error, caught) => {
            if (!noDefaultPrintAction) {
                return printErrorHandler(error, url, this.translateService, this.globalComponentService, this.words, this.isBrowser, this.loggerService);
            }
            else {
                return throwError(error);
            }
        }));
    }
    put(url, data, options, noDefaultPrintAction = false) {
        return this.http.put(`${url}`, data, options).pipe(catchError((error, caught) => {
            if (!noDefaultPrintAction) {
                return printErrorHandler(error, url, this.translateService, this.globalComponentService, this.words, this.isBrowser, this.loggerService);
            }
            else {
                return throwError(error);
            }
        }));
    }
    delete(url, options, noDefaultPrintAction = false) {
        return this.http.delete(`${url}`, options).pipe(catchError((error, caught) => {
            if (!noDefaultPrintAction) {
                return printErrorHandler(error, url, this.translateService, this.globalComponentService, this.words, this.isBrowser, this.loggerService);
            }
            else {
                return throwError(error);
            }
        }));
    }
    onHttpRequest(req) {
        const isServer = isPlatformServer(this.platformId);
        const isSSRMode = isServer || this.transferState.hasKey(CSP_NONCE_KEY);
        const key = `${req.method}.${req.urlWithParams.replace(this.generatorEnv.apiHost, '')}`;
        if (isSSRMode) {
            if (isServer) {
                this.loggerService.info(`HTTP request: ${key}`);
                // server side 處理 api http 請求
                const cachedData = memoryCache.get(key);
                if (cachedData) {
                    this.transferState.set(makeStateKey(key), cachedData);
                    this.loggerService.info(`HTTP response from MemoryCache: ${key}`);
                    return of(cachedData.body);
                }
            }
            else {
                // broswer side 處理 api http 請求
                // if (req.method !== 'GET') {
                //   return next.handle(req);
                // }
                const storedResponse = this.transferState.get(makeStateKey(key), null);
                if (storedResponse) {
                    this.loggerService.info(`HTTP request: ${key}`);
                    const response = storedResponse;
                    this.loggerService.info(`HTTP response: ${key}\n`, response);
                    return of(response.body);
                }
            }
        }
        return new Observable(observer => {
            this.http.request(req).subscribe((event) => {
                switch (event.type) {
                    case HttpEventType.Sent:
                        break;
                    case HttpEventType.UploadProgress:
                        break;
                    case HttpEventType.Response:
                        if (isSSRMode && isServer) {
                            // if (event instanceof HttpResponse) {
                            this.transferState.set(makeStateKey(key), event);
                            // console.log(`${moment().format('YYYY/MM/DD')} HTTP response: ${key}\n`, JSON.stringify(event));
                            // this.ngZone.runOutsideAngular(() => {
                            //   memoryCache.put(key, event, 1000 * 60);
                            // });
                            // }
                        }
                        observer.next(event.body);
                        observer.complete();
                }
            }, error => {
                observer.error(error);
                observer.complete();
            });
        });
    }
}
CommonHttpClientService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CommonHttpClientService_Factory() { return new CommonHttpClientService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.GlobalComponentService), i0.ɵɵinject(i3.TranslateService), i0.ɵɵinject(i0.PLATFORM_ID), i0.ɵɵinject(i4.TransferState), i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i5.LoggerService), i0.ɵɵinject(i6.GENERATOR_ENV_TOKEN)); }, token: CommonHttpClientService, providedIn: "root" });
